import axios from 'axios'
export default async (username,image) => {
    let backend= "https://api-dashboard.oned.io"
    let backend2= "http://localhost:3000"
    let return_value=await axios.put(`${backend}/login/setProfilePhoto/${username}`,
    {
      profile_image:image,
    },
    {
      headers:{
        Authorization: 'Bearer ' + $cookies.get('user'),
      }
    })
      return return_value
}